var exports = {
  "Vg": "grid__XQhf-S",
  "ZK": "hero__LLSDMM",
  "xg": "heroPrimaryButton__UsluQA",
  "c8": "heroImage__hewvri",
  "Mw": "formWrapper__UEjpPv",
  "K5": "hiddenOnMobile__BYAn4w",
  "Z9": "tagsWrapper__erZTgu",
};

module.exports = exports;
